import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsServicesListArticleAttributeInterface,
    ServicesListInterface,
} from '~/src/repositories/cms/entities/main/types/cms.services-list.types';

export const getMappedServicesListData = (
    data: DictionaryInterface<CmsServicesListArticleAttributeInterface>[] | [],
): ServicesListInterface[] => {
    return (data?.[0]?.articles || [])
        .reduce<ServicesListInterface[]>((services, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const servicesList = elem.attributeCategories.potentsialnaya_pribyl?.attributes;
                services.push({
                    id: elem.id,
                    link: servicesList?.knowledge_link?.value || null,
                    change: servicesList?.period?.value || null,
                    description: servicesList?.product_description?.value || null,
                    title: servicesList?.product_name?.value || null,
                    value: servicesList?.summ?.value || null,
                    image: servicesList?.image?.value || null,
                    order: elem?.order || fallBackOrder,
                    sefUrl: elem?.sefUrl || null,
                });
            }

            return services;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};